import axios from 'axios'

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL || '/api/',
})

export default {
    async logonWithUsernameAndPassword(username, password) {
        let result = await instance.post('/auth/password', {
            username: username,
            password: password,
        })

        return result.data
    },

    async logonWithMsalAccessToken(token) {
        let result = await instance.post('/auth/msalAccessToken', {
            token: token,
        })

        return result.data
    },

    async getImpersonationToken(token, user_id) {
        let result = await instance.post(
            '/auth/impersonateUser',
            {
                user_id: user_id,
                token: token,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            }
        )

        return result.data
    },

    async getUserFromToken(token) {
        let result = await instance.get('/me', {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })

        return result.data
    },

    // async fetchUserFromToken(token) {},

    // getUserIdFromToken(token) {},

    // async validateToken(token) {},
}
